/* eslint-disable camelcase */
import React from 'react';
import he from 'he';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import Link from '@/components/atoms/Link/Link';
import { useTranslation } from '@/src/i18n';
import { APP_ROUTES } from '@/src/constants';
import config from '@/src/config';
import { analyticsEvent } from '@/src/analytic_tag_manager';

const ArticleCardsList = (props: { articles: Article[] }) => {
  const { articles = [] } = props;
  const { t } = useTranslation('common');

  if (articles.length === 0) return null;
  return (
    <div id="related-articles">
      <Typography className="title">{t('article-more-content')}</Typography>
      <ul className="cards-list">
        {articles.map(article => {
          /**
           * Links from wordpress https://news.maiia.com/speciality/slug1/slug2
           * Instead of guessing the speciality from the router we use the one
           * from the article's link, it's 100% garanteed that it's correct
           */
          const [speciality, ...slugs] = article.link
            ?.replace(
              `${config.get('NEXT_PUBLIC_PAT_MAIIA_NEWS_BASEURL')}/`,
              '',
            )
            .split('/');
          return (
            <li key={article.slug} className="related-article-card">
              <Link
                href={{
                  pathname: APP_ROUTES.SPECIALITY.ARTICLE,
                  query: {
                    speciality,
                    'article-slugs': slugs,
                  },
                }}
                legacyBehavior
              >
                <a
                  onClick={() =>
                    analyticsEvent({
                      category: 'SEO_Article',
                      action: 'SEO_Article_Suggestion',
                      label: speciality,
                    })
                  }
                >
                  <div
                    className="card-image"
                    style={{
                      // Yoast will use the featured image by default, unless 'og_image' was
                      // changed manually
                      backgroundImage: `url(${article.yoast_head_json
                        ?.og_image?.[0].url ||
                        '/static/images/article-default-thumb.png'})`,
                    }}
                  />

                  <Typography variant="h4" component="p" align="center">
                    {he.decode(article?.title?.rendered)}
                  </Typography>

                  <Typography className="article-reading-time">
                    {article.readingTime}
                  </Typography>

                  <Typography className="article-date">
                    {`${t('article-publish-date')} ${dayjs(article.date).format(
                      'DD.MM.YYYY',
                    )}`}
                  </Typography>
                </a>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
export default ArticleCardsList;
